module.exports = __webpack_public_path__ + "img/alfie-w13.7664071a.jpeg";